import React, { useState } from 'react';
import axios from 'axios';
import { useEffect, useContext } from 'react';
import { AuthContext } from '../AuthContext.js';
import CrearUsuario from './CrearUsuario.jsx';
import AdmFamilia from './AdmFamilia.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import {faPencil, faTrash, faKey} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PanelAdm() {
    const [activeModal, setActiveModal] = useState(null);
    const { user } = useContext(AuthContext);
    const [usuarios, setUsuarios] = useState([]);

    const [editingUser, setEditingUser] = useState(null);
    const [editForm, setEditForm] = useState({ username: '', role: '' });



    const openModal = (modalName) => setActiveModal(modalName);
    const closeModal = () => setActiveModal(null);

    const fetchUsuarios = async () => {
        try {
            const response = await axios.get("https://socios.kolpingchile.cl/backend/api/usuarios", {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            setUsuarios(response.data);
        } catch (error) {
            console.error("Error al cargar usuarios:", error);
        }
    };
    useEffect(() => {
        if (user?.role === "Administrador") {
            fetchUsuarios();
        }
    }, [user]);

    const openEditModal = (user) => {
        setEditingUser(user);
        setEditForm({ username: user.username || '', role: user.role || '' });
        openModal('editUsuario');
    };

    const closeEditModal = () => {
        setEditingUser(null);
        setEditForm({ username: '', role: '' });
        closeModal();
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditForm(prev => ({ ...prev, [name]: value }));
    };

    const handleUpdateUser = async () => {
        if (!editingUser) return;
        try {
            const payload = { username: editForm.username, role: editForm.role };
            await axios.put(`https://socios.kolpingchile.cl/backend/api/usuarios/${editingUser.id}`, payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            // Actualiza la lista localmente para reflejar el cambio sin recargar
            setUsuarios(prev => prev.map(u => (u.id === editingUser.id ? { ...u, ...payload } : u)));
            closeEditModal();
        } catch (error) {
            console.error('Error al actualizar usuario:', error);
        }
    };

    const handleDeleteUser = async (userId) => {
        const confirmDelete = window.confirm(
            "¿Estás seguro de que deseas eliminar este usuario? Esta acción no se puede deshacer."
        );

        if (!confirmDelete) return;

        try {
            await axios.delete(`https://socios.kolpingchile.cl/backend/api/usuarios/${userId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            window.alert("Usuario eliminado correctamente");

            // Actualiza la lista localmente
            setUsuarios(prev => prev.filter(u => u.id !== userId));

        } catch (error) {
            console.error('Error al eliminar usuario:', error);
            window.alert("Error al eliminar el usuario");
        }
    };

    const resetPassword = async (userId) => {
        const confirmReset = window.confirm(
            "¿Deseas restablecer la contraseña de este usuario? Se generará una nueva contraseña."
        );

        if (!confirmReset) return;

        try {
            await axios.post(
                `https://socios.kolpingchile.cl/backend/api/usuarios/${userId}/reset-password`,
                { username: usuarios.find(u => u.id === userId)?.username }, // Enviar el username para generar la contraseña
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                }
            );

            window.alert("Contraseña restablecida correctamente. Utilizar contraseña por defecto.");
            fetchUsuarios(); // Refresca la lista para mostrar el cambio de must_change_password

        } catch (error) {
            console.error('Error al restablecer contraseña:', error);
            window.alert("Hubo un error al restablecer la contraseña.");
        }
    };

    const toBoolean = (b)=>{
        if(b === 0) return "No";
        if(b === 1) return "Sí";
        return b;
    }
    

    return (
        <div className="container py-5 bg-white rounded">
            <h1 className="text-center mb-5 fw-bold text-primary">Panel de Administración</h1>

            <div className="row g-4">
                {/* GESTIÓN DE USUARIOS */}
                <div className="col-md-6">
                    <div className="card border-0">
                        <div className="card-body">
                            <h2 className="h5 fw-bold text-secondary mb-3">👥 Gestión de Usuarios</h2>
                            <div className="d-grid gap-3">
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={() => openModal('configUsuarios')}
                                >
                                    Gestión de Usuarios Existentes
                                </button>

                                <button
                                    className="btn btn-outline-success"
                                    onClick={() => openModal('crearUsuario')}
                                >
                                    Crear Nuevo Usuario
                                </button>

                                {/* <button
                                    className="btn btn-outline-danger"
                                    onClick={() => openModal('eliminarUsuario')}
                                >
                                    Eliminar Usuario
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* GESTIÓN DE FAMILIAS */}
                <div className="col-md-6">
                    <div className="card border-0">
                        <div className="card-body">
                            <h2 className="h5 fw-bold text-secondary mb-3">🏠 Gestión de Familias</h2>
                            <div className="d-grid gap-3">
                                {/* <button
                                    className="btn btn-outline-primary"
                                    onClick={() => openModal('gestionarFamilias')}
                                >
                                    Gestionar Familias Existentes
                                </button> */}

                                <button
                                    className="btn btn-outline-success"
                                    onClick={() => openModal('crearFamilia')}
                                >
                                    Crear Nueva Familia
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Modal Configuración de Usuarios */}
            <div className={`modal fade ${activeModal === 'configUsuarios' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title">Configuración de Usuarios</h5>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body">
                            <h4>Usuarios existentes</h4>
                            <table border="1" cellPadding="8" style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th>Username</th>
                                        <th>Nombre</th>
                                        <th>Rol</th>
                                        <th>Cambio de Contraseña</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuarios.length > 0 ? (
                                        usuarios.map((u) => (
                                            <tr key={u.id}>
                                                <td>{u.username}</td>
                                                <td>{u.nombre}</td>
                                                <td>{u.role}</td>
                                                <td>{toBoolean(u.must_change_password)}</td>
                                                <td>
                                                    <button title="Editar" className="btn btn-sm btn-outline-warning me-2" onClick={() => openEditModal(u)}>
                                                        <FontAwesomeIcon icon={faPencil} />
                                                    </button>
                                                    <button title="Eliminar" className="btn btn-sm btn-outline-danger me-2" onClick={() => handleDeleteUser(u.id)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <button title="Restablecer Contraseña" className="btn btn-sm btn-outline-secondary" onClick={() => resetPassword(u.id)}>
                                                        <FontAwesomeIcon icon={faKey} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                No hay usuarios registrados
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Crear Usuario */}
            <div className={`modal fade ${activeModal === 'crearUsuario' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-success text-white">
                            <h5 className="modal-title">Crear Usuario</h5>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body">
                            <CrearUsuario />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Eliminar Usuario */}
            {/* <div className={`modal fade ${activeModal === 'eliminarUsuario' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-danger text-white">
                            <h5 className="modal-title">Eliminar Usuario</h5>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro de que deseas eliminar un usuario? Esta acción no se puede deshacer.</p>
                            <div className="d-flex justify-content-end gap-2">
                                <button className="btn btn-outline-secondary" onClick={closeModal}>Cancelar</button>
                                <button className="btn btn-danger">Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* Modal Editar Usuario */}
            <div className={`modal fade ${activeModal === 'editUsuario' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-warning text-white">
                            <h5 className="modal-title">Editar Usuario</h5>
                            <button type="button" className="btn-close" onClick={closeEditModal}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Nombre de Usuario</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={editForm.username}
                                    onChange={(e) => handleEditChange({ target: { name: 'username', value: e.target.value } })}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Rol</label>
                                <select
                                    className="form-select"
                                    value={editForm.role}
                                    onChange={(e) => handleEditChange({ target: { name: 'role', value: e.target.value } })}
                                >
                                    <option value="Administrador">Administrador</option>
                                    <option value="Secretario">Secretario</option>
                                    <option value="Digitador">Digitador</option>
                                    <option value="Lector">Lector</option>
                                    <option value="Ejecutivo">Ejecutivo</option>
                                    <option value="Contador">Contador</option>
                                </select>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeEditModal}>Cancelar</button>
                            <button className="btn btn-warning" onClick={handleUpdateUser}>Guardar Cambios</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Gestionar Familias */}
            <div className={`modal fade ${activeModal === 'gestionarFamilias' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title">Gestionar Familias Existentes</h5>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body">

                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Crear Familia */}
            <div className={`modal fade ${activeModal === 'crearFamilia' ? 'show d-block' : ''}`} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header bg-success text-white">
                            <h5 className="modal-title">Crear Nueva Familia</h5>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body">
                            <AdmFamilia modo="crear" />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelAdm;
